import { NTSReflection } from '@nts/std/utility';

const IDENTITY_TYPE_NAME_META_DATA_IDENTIFICATION_KEY = 'identityTypeNameDecoratorMetaDataKey';

export function IdentityTypeNameDecorator(identityTypeName: string) {
    return (target: any) => {
        Reflect.defineMetadata(IDENTITY_TYPE_NAME_META_DATA_IDENTIFICATION_KEY, identityTypeName, target);
    };
}

export class IdentityTypeNameInspector {

    static META_DATA_KEY = IDENTITY_TYPE_NAME_META_DATA_IDENTIFICATION_KEY;
    static DECORATOR_NAME = '@IdentityTypeNameDecorator';

    static isApplied(subject: any): boolean {
        return NTSReflection.hasClassMetadata(
            IDENTITY_TYPE_NAME_META_DATA_IDENTIFICATION_KEY, subject);
    }

    static getValue(subject: any): string {
        return NTSReflection.getClassMetadata(
            IDENTITY_TYPE_NAME_META_DATA_IDENTIFICATION_KEY, subject);
    }
}
